<template>
  <section id="SectionPlantTypes">
    <Wrap class="lg">
      <h2 class="title">
        {{ $t('title') }}
      </h2>
      <CardPlant v-for="plant in plants" :key="plant.label" :plant="plant" />
    </Wrap>
  </section>
</template>

<script>
import CardPlant from './CardPlant'
import { mergeLabels } from '../../../utils'

export default {
  components: { CardPlant },
  data() {
    return {
      images: [
        {
          image: './../../../../assets/plants/slaitinis-stogas-su-stoglangiu.jpg',
          alt: 'Ant stogo dangos',
        },
        {
          image: './../../../../assets/plants/horizotalus-moguliu-isdestymas.jpg',
          alt: 'Ant plokščio stogo',
        },
        {
          image: './../../../../assets/plants/antzemine-elektrines.jpg',
          alt: 'Antžeminė',
        },
        // {
        //   image: './../../../../assets/plants/integruota-i-stoga.jpg',
        //   alt: 'Integruota į stogą',
        // },
        // {
        //   image: './../../../../assets/plants/elektrines-ant-fasado.jpg',
        //   alt: 'Ant fasado',
        // },
      ],
    }
  },
  computed: {
    plants() {
      return mergeLabels(this.images, this.$ta('plants'))
    },
  },
}
</script>
<style lang="scss">
#SectionPlantTypes {
  .title {
    padding-bottom: 2rem;
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Saulės elektrinių tipai",
    "plants": [
      {
        "label": "Ant stogo dangos",
        "text": "Ant šlaitinio stogo tvirtinamos saulės elektrinės yra populiariausias namų savininkų pasirinkimas. Saulės modulių išdėstymą pritaikysime jūsų stogui, kad garantuotume maksimalų elektrinės našumą."
      },
      {
        "label": "Ant plokščio stogo",
        "text": "Plokščias stogas taip pat puikiai tinka saulės elektrinei įrengti. Ant stogo sumontuosime konstrukcijas, kurios užtikrins optimalų saulės modulių pasvirimo kampą ir efektyvumą."
      },
      {
        "label": "Antžeminė",
        "text": "Antžeminės elektrinės yra puikus sprendimas, kai pastato stogas yra netinkamas papildomoms konstrukcijoms montuoti. Ant žemės įrengtos saulės modulių konstrukcijos nealina žemės ir yra lengvai prižiūrimos."
      }
    ]
  }
}
</i18n>
